import { render } from "./Documento.vue?vue&type=template&id=ea473a00&scoped=true"
import script from "./Documento.vue?vue&type=script&lang=js"
export * from "./Documento.vue?vue&type=script&lang=js"

import "./Documento.vue?vue&type=style&index=0&id=ea473a00&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea473a00"]])

export default __exports__